var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',[_vm._v("ceci est un test")]),_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('carousel-meb',{attrs:{"slides":_vm.json.data['carousel-meb']}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }